export enum PagesPaths {
    TASK = 'task',
    TASK_LIST = 'task-list',
    ROOT = '/',
    NOT_FOUND = '404',
    ERROR = 'error-page',
}
